// @flow
import React from 'react'

type Props = {

};

const DataDisplay = (props: Props) => {
    return (
      <>TODO</>
    )
}

export default DataDisplay